import { render, staticRenderFns } from "./SoftwareFields.vue?vue&type=template&id=3c441efc"
import script from "./SoftwareFields.vue?vue&type=script&lang=js"
export * from "./SoftwareFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports